import { AxiosResponse } from 'axios'

import { User } from 'types/user'

import { _axiosMain } from './axios'

const GET_ME = `/users/me`

export const userApi = () => {
  const getMe = async (): Promise<AxiosResponse<User>> => {
    return await _axiosMain()
      .get(GET_ME)
      .then((res) => {
        res.data = res.data.user
        return res
      })
  }

  return {
    getMe,
  }
}
